module.exports = __webpack_public_path__ + "img/banner_generic_left.cc37777f.jpg";